import { commonProfHandler } from "./commonProfHandler";

export const dlHandler = commonProfHandler({
  productCode: "DL",
  productName: "DOCTOR",
});
